import React, { useState, useRef, useEffect } from "react";
import { inject, observer } from "mobx-react";
import Utility from "../../../common/utility";
import ApiCalls from "../../apis/api-calls";
import GenerateSubLicenseForm from "./GenerateSubLicenseForm";
import "../../../assets/css/components/Profile/EnvironmentSelection/EnvironmentSelection.css";
import LicenseTab from "./LicenseTab/LicenseTab";
import Icon from "react-icons-kit";
import { angleUp } from "react-icons-kit/fa/angleUp";
import { ic_change_history } from "react-icons-kit/md/ic_change_history";
import { close } from "react-icons-kit/fa/close";
import { infoCircle } from "react-icons-kit/fa/infoCircle";

const LicenseComponent = inject("sharedStore")(
  observer(store => {
    const {
      sharedStore: { customerSeriesType, companyLicenseType, numberOfLicenses }
    } = store;
    const [popup, setPopup] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showSubLicenseModal, setShowSubLicenseModal] = useState(false);
    const [showDeactiveModal, setShowDeactiveModal] = useState(false);
    const [licensesNumber, setLicensesNumber] = useState({});
    const [total, setTotal] = useState(0);
    const [
      subLicenseGenerationEnabled,
      setSubLicenseGenerationEnabled
    ] = useState(false);
    const node1 = useRef(null);
    const node2 = useRef(null);
    useEffect(() => {
      if (numberOfLicenses && numberOfLicenses.total) {
        setLicensesNumber(numberOfLicenses);
        setTotal(numberOfLicenses.total);
        setSubLicenseGenerationEnabled(numberOfLicenses.creation_allowed);
      } else {
        ApiCalls.fetchNumberOfLicenses({
          company_id: Utility.getData("companyId")
        })
          .then(res => {
            if ((res.status_code = 200)) {
              setLicensesNumber(res);
              setTotal(res.total);
              setSubLicenseGenerationEnabled(res.creation_allowed);
            } else {
              setLicensesNumber({});
              setTotal(0);
              setSubLicenseGenerationEnabled(false);
            }
          })
          .catch(err => {
            console.log(err);
            setLicensesNumber({});
            setTotal(0);
            setSubLicenseGenerationEnabled(false);
          });
      }
    }, []);

    const handleClick = (e, type) => {
      if (type) {
        // attach/remove event handler
        document.addEventListener("click", handleOutsideClick, false);
      } else {
        document.removeEventListener("click", handleOutsideClick, false);
      }
      setPopup(type);
    };

    const handleOutsideClick = e => {
      // ignore clicks on the component itself
      if (
        (node1.current && node1.current.contains(e.target)) ||
        (node2.current && node2.current.contains(e.target))
      ) {
        return;
      }
      handleClick();
    };

    const triggerErrorModal = () => {
      setShowErrorModal(!showErrorModal);
    };

    const triggerSubLicenseModal = () => {
      setShowSubLicenseModal(!showSubLicenseModal);
    };

    const handleSubLicense = () => {
      if (total > 0) {
        triggerSubLicenseModal();
      } else {
        triggerErrorModal();
      }
    };
    const triggerdeactiveModal = () => {
      setShowDeactiveModal(!showDeactiveModal);
    };

    return (
      <div className="app-tab-wrapper tab-wrapper ">
        <div className="row">
          <div className="col-xs-12 col-sm-7 col-md-7">
            {/* for 6 & 7 customer */}
            {customerSeriesType === 1 ? (
              <div className="lin_wrapper">
                Licenses - 7 Series
                <div className="info_iocns">
                  <Icon
                    className="info_circle_icons"
                    size={25}
                    icon={infoCircle}
                  />
                  <div className="note-text">
                    <span className="down_arrow">
                      <Icon size={40} icon={angleUp} />
                    </span>
                    <ol
                      className={
                        companyLicenseType === "Offline"
                          ? "offline_list"
                          : "online_list"
                      }
                    >
                      <li>
                        Only 7 series licenses will display in portal. You will
                        be contacted via email once 6 license keys are ready
                      </li>
                      {companyLicenseType === "Offline" ? (
                        <li>
                          For invoices paid via ACH/bank account, licenses will
                          be updated once payment has been processed. You will
                          be notified via email once your licenses have been
                          updated.
                        </li>
                      ) : null}
                    </ol>
                  </div>
                </div>
              </div>
            ) : null}
            {/* end of 6 & 7 customer */}

            {/* for 7-migration or new customer having offline license */}
            {customerSeriesType === 2 || customerSeriesType === 3 ? (
              <div className="lin_wrapper">
                Licenses
                {companyLicenseType === "Offline" ? (
                  <div className="info_iocns">
                    <Icon
                      className="info_circle_icons"
                      size={25}
                      icon={infoCircle}
                    />
                    <div className="note-text">
                      <span className="down_arrow">
                        <Icon size={40} icon={angleUp} />
                      </span>
                      <ul>
                        <li>
                          For invoices paid via ACH/bank account, licenses will
                          be updated once payment has been processed. You will
                          be notified via email once your licenses have been
                          updated.
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
            {/* end of for 7-migration or new customer having offline license */}
          </div>
          {/* {customerSeriesType === 1 ? (
            <div className="helpTxt_wrapper" ref={node1}>
              <span className="helptxt" onClick={e => handleClick(e, 1)}>
                {" "}
                What am i seeing?
              </span>
              {popup === 1 && (
                <div className="note-text">
                  <span className="down_arrow">
                    <Icon size={40} icon={angleUp} />
                  </span>
                  <ol>
                    <li>
                      Only 7 series licenses will display in portal. You will be
                      contacted via email once 6 license keys are ready
                    </li>
                    {companyLicenseType === "Offline" ? (
                      <li>
                        For invoices paid via ACH/bank account, licenses will be
                        updated once payment has been processed. You will be
                        notified via email once your licenses have been updated.
                      </li>
                    ) : null}
                  </ol>
                </div>
              )}
            </div>
          ) : null} */}
          {/* {customerSeriesType === 2 || customerSeriesType === 3 ? (
            <div>
              {" "}
              {companyLicenseType === "Offline" ? (
                <div className="seven_seriestxt">
                  Note: For invoices paid via ACH/bank account, licenses will be
                  updated once payment has been processed. You will be notified
                  via email once your licenses have been updated.
                </div>
              ) : null}
            </div>
          ) : null} */}
          <div className="col-xs-12 col-sm-5 col-md-5">
            {subLicenseGenerationEnabled ? (
              <div className="help_txt_wrapper">
                <div className="help_wrapper" ref={node2}>
                  <span className="POpUpLink" onClick={e => handleClick(e, 2)}>
                    <span className="POpUpText">
                      <Icon
                        className="upArrowpopUp"
                        size={40}
                        icon={ic_change_history}
                      />
                      Need to edit an existing sub-client license? Please
                      contact licensing@izenda.com for assistance.
                    </span>
                    <Icon
                      className="info_circle_icons"
                      size={25}
                      icon={infoCircle}
                    />
                  </span>
                </div>
                <button
                  type="button"
                  className={
                    total === 0
                      ? "btn btn-primary gntNewSubClientLic-btn licenseadd"
                      : "btn btn-primary gntNewSubClientLic-btn licenseadd"
                  }
                  onClick={handleSubLicense}
                >
                  Generate New Sub-Client License ({total})
                </button>
              </div>
            ) : (
              <button
                type="button"
                className="btn btn-primary gntNewSubClientLic-btn cus_dac_btn licenseadd"
                onClick={triggerdeactiveModal}
              >
                Generate New Sub-Client License ({total})
              </button>
            )}
          </div>
        </div>
        <div className="tab-content bgTabContent">
          <div className="tab-pane fade in active">
            <LicenseTab />
          </div>
        </div>
        {showErrorModal && (
          <div className="sub_licen_modal">
            <div className="sub_licen_body">
              <div className="sub_modal_header">
                <span className="close_licen">
                  <Icon size={20} icon={close} onClick={triggerErrorModal} />
                </span>
              </div>
              <div className="sub_modal_contant">
                <p>
                  You have <span className="lictxt">0</span> sub-clicent
                  licenses remaining.
                </p>
                <p>
                  If you feel this is incorrect or would like to purchase
                  additional sub-client licenses, please contact
                </p>
                <p>
                  <a href="mailto:sales@izenda.com">sales@izenda.com</a>
                </p>
                <p>
                  <a
                    href="mailto:sales@izenda.com"
                    className="licbtnok"
                    onClick={triggerErrorModal}
                  >
                    Contact Now
                  </a>
                </p>
              </div>
            </div>
          </div>
        )}
        {showSubLicenseModal && (
          <GenerateSubLicenseForm
            triggerSubLicenseModal={triggerSubLicenseModal}
          />
        )}
        {showDeactiveModal && (
          <div className="sub_licen_modal">
            <div className="sub_licen_body">
              <div className="sub_modal_header">
                <span className="close_licen">
                  <Icon size={20} icon={close} onClick={triggerdeactiveModal} />
                </span>
              </div>
              <div className="sub_modal_contant">
                <p>
                  This functionality has been deactivated for your account. If
                  you have any question or feel that is incorrect, please
                  contact licensing@izenda.com
                  <div className="mail_btn">
                    <a
                      href="mailto:licensing@izenda.com"
                      className="licbtnok"
                      onClick={triggerdeactiveModal}
                    >
                      Contact Now
                    </a>
                  </div>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  })
);

export default LicenseComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/LicenseComponent/LicenseComponent.js